<template>
  <div id="app">
    <router-view />
    <el-tooltip ref="globalTooltip" :content="tipContent" placement="top"></el-tooltip>
    <audio id="chatAudio" v-show="false">
      <source src="/sound/notify.ogg" type="audio/ogg" />
      <source src="/sound/notify.mp3" type="audio/mpeg" />
      <source src="/sound/notify.wav" type="audio/wav" />
    </audio>
  </div>
</template>

<script>
import { disconnect } from "@/utils/socket"

export default {
  name: "app",
  data: function() {
    return {
      tipContent: "xixi"
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    this.initTooltip()
  },
  beforeDestroy() {
    disconnect() // 断开websocket
  },
  methods: {
    initTooltip() {
      let tooltip = this.$refs.globalTooltip
      let debounceShow = this._.debounce(t => t.handleShowPopper(), 50)
      // let debounceHide = this._.debounce(t => t.handleClosePopper(), 100)
      window.showTip = (el, content) => {
        tooltip.referenceElm = el
        this.tipContent = content
        tooltip.$refs.popper && (tooltip.$refs.popper.style.display = "none")
        tooltip.doDestroy()
        tooltip.setExpectedState(true)
        debounceShow(tooltip)
      }
      window.hideTip = () => {
        tooltip.setExpectedState(false)
        tooltip.handleClosePopper()
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  height: 100%;
}
</style>
